import { render, staticRenderFns } from "./unit.vue?vue&type=template&id=ff85337c&scoped=true&"
import script from "./unit.vue?vue&type=script&lang=js&"
export * from "./unit.vue?vue&type=script&lang=js&"
import style0 from "./unit.vue?vue&type=style&index=0&id=ff85337c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff85337c",
  null
  
)

export default component.exports